var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mode == "bar"
    ? _c("div", [
        _c(
          "div",
          { staticClass: "wrapper-semaforo con-ombra" },
          [
            _vm.buttons.includes("play")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "secondary white--text ma-0",
                    attrs: {
                      icon: "",
                      small: "",
                      rounded: "",
                      depressed: "",
                      disabled: !(
                        (_vm.asta_info.counter > 0 || _vm.premium) &&
                        _vm.not_running
                      ),
                    },
                    on: { click: _vm.avviaAsta },
                  },
                  [
                    _c("v-icon", { attrs: { small: "", light: "" } }, [
                      _vm._v("play_arrow"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.buttons.includes("pause")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "orange white--text ma-0",
                    attrs: {
                      icon: "",
                      small: "",
                      depressed: "",
                      disabled: !_vm.running,
                    },
                    on: { click: _vm.pausaAsta },
                  },
                  [
                    _c("v-icon", { attrs: { small: "", light: "" } }, [
                      _vm._v("pause"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.buttons.includes("stop")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "red lighten-1 white--text ma-0",
                    attrs: { icon: "", small: "", depressed: "" },
                    on: { click: _vm.fermaAsta },
                  },
                  [
                    _c("v-icon", { attrs: { small: "", light: "" } }, [
                      _vm._v("stop"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }